import TransactionFile from './sendCsvToEmail';
import transformError from '../shared/transformers/errorTransformer';

export default {
  sendTransactionFileToEmail({
    email,
    start_date,
    end_date,
    transaction_type,
    package_name,
  }) {
    return TransactionFile.sendTransactionFileToEmail(
      { package: package_name },
      {
        start_date,
        end_date,
        transaction_type,
        receiver_email: email,
      },
    ).catch(transformError);
  },
};
